import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import initialData from "../../../../utilities/initialData/initialData";
import KonfiguracjaService from "../../../administracja/konfiguracja/KonfiguracjaService";
import * as acc from "accounting";
import MiesieczneTableStatus from "../../../konfiguracja/biletyConfig/biletyMiesieczne/components/MiesieczneTableStatus";
import tabgrid from "../../../../utilities/TabGrid";
import InfoTooltip from "../../../../componentsTopsa/infoTooptip/InfoTooltip";
import TopExportCSV from "../../../../componentsTopsa/exportCSV/TopExportCSV";

export default class UrzadMiesieczneTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            kolumnyDoExportuDefault: [
                {value: "id_bm", label: 'ID biletu'},
                {value: "id_kl", label: 'ID klienta'},
                {value: "data_sprz", label: 'Data sprzedaży'},
                {value: "nazwa_linii", label: 'Nazwa linii'},
                {value: "trasa", label: 'Trasa'},
                {value: "odcinek_trasy", label: 'Odcinek trasy'},
                {value: "km", label: 'KM'},
                {value: "wazny_od", label: 'Wazny od'},
                {value: "wazny_do", label: 'Wazny do'},
                {value: "nr_bileterki", label: 'Nr bileterki'},
                {value: "nr_gr_ulgi", label: 'Nr grupy ulgi'},
                {value: "nazwa_ulgi", label: 'Nazwa ulgi'},
                {value: "proc_ulgi", label: 'Procent ulgi'},
                {value: "ilosc", label: 'Ilość'},
                {value: "ilosc_popr", label: 'Ilość poprawna'},
                {value: "cena_biletu", label: 'Cena biletu'},
                {value: "doplata", label: 'Dopłata'},
                {value: "cena_biletu_netto", label: 'Cena biletu netto'},
                {value: "doplata_netto", label: 'Dopłata netto'},
            ],
            wszystkieKolumnyEksport: [
                {value: "id_bm", label: 'ID biletu'},
                {value: "id_kl", label: 'ID klienta'},
                {value: "data_sprz", label: 'Data sprzedaży'},
                {value: "nazwa_linii", label: 'Nazwa linii'},
                {value: "trasa", label: 'Trasa'},
                {value: "odcinek_trasy", label: 'Odcinek trasy'},
                {value: "km", label: 'KM'},
                {value: "wazny_od", label: 'Wazny od'},
                {value: "wazny_do", label: 'Wazny do'},
                {value: "nr_bileterki", label: 'Nr bileterki'},
                {value: "nr_gr_ulgi", label: 'Nr grupy ulgi'},
                {value: "nazwa_ulgi", label: 'Nazwa ulgi'},
                {value: "proc_ulgi", label: 'Procent ulgi'},
                {value: "ilosc", label: 'Ilość'},
                {value: "ilosc_popr", label: 'Ilość poprawna'},
                {value: "cena_biletu", label: 'Cena biletu'},
                {value: "doplata", label: 'Dopłata'},
                {value: "cena_biletu_netto", label: 'Cena biletu netto'},
                {value: "doplata_netto", label: 'Dopłata netto'},
            ],

        };
    }


    formatNaglowek(str) {
        return <span style={{fontSize: "10px"}}>{str}</span>
    }

    formatSmallText(cell, row) {
        return <span style={{fontSize: "11px"}}>{cell}</span>
    }

    formatSmallerText(cell, row) {
        return <span style={{fontSize: "10px"}}>{cell}</span>
    }

    formatCeny(cell, row) {
        return <span style={{fontSize: "11px"}}>{cell.toFixed(2)}</span>
    }

    formatIloscPopr(cell, row) {
        if (row.ilosc == cell) {
            return <span style={{fontSize: "11px"}}>{cell}</span>
        } else {
            return <div style={{fontSize: "11px", background: "yellow", color: "red", fontWeight: "bold"}}
                        title={"Ilość sprzedana i poprawna się nie zgadzają!"}>{cell}</div>
        }
    }

    render() {
        const options = {
            sizePerPage: 15,  // Showing 30 for the size per page as default
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów',
        };

        return (
            <div>
                <div>
                    <TopExportCSV daneRest={this.props.data} wszystkieKolumny={this.state.wszystkieKolumnyEksport}
                                  kolumnyDoExportu={this.state.kolumnyDoExportuDefault}/>
                </div>
                <div>
                    <div className={'pull-right'} style={{fontSize: '12px', color: 'grey', padding: '5px', fontStyle: 'italic'}}>
                        Ilość wyszukanych biletów: {Boolean(this.props.data) ? this.props.data.length : 0}
                    </div>
                </div>
                <div>
                    <BootstrapTable data={this.props.data}
                                    options={options}
                                    pagination
                                    hover
                    >
                        <TableHeaderColumn dataField='id_bm' isKey expandable={false}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={this.formatSmallText} dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                        >{this.formatNaglowek("Nr biletu")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='id_kl' expandable={false}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={this.formatSmallText} dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                        >{this.formatNaglowek("ID klienta")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='data_sprz'
                                           dataFormat={this.formatSmallText} dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                        >{this.formatNaglowek("Data sprzedaży")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='nazwa_linii'
                                           dataFormat={this.formatSmallerText} dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                        >{this.formatNaglowek("Linia")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='trasa'
                                           dataFormat={this.formatSmallText} dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                        >{this.formatNaglowek("Trasa")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='odcinek_trasy'
                                           dataFormat={this.formatSmallText} dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                        >{this.formatNaglowek("Odcinek")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='km'
                                           dataFormat={this.formatSmallText} dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                        >{this.formatNaglowek("KM")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='waznyod_waznydo'
                                           dataFormat={this.formatSmallText} dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                        >{this.formatNaglowek("Ważny od - do")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='nr_bileterki'
                                           dataFormat={this.formatSmallerText} dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                        >{this.formatNaglowek("Nr bileterki")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='nr_gr_ulgi'
                                           dataFormat={this.formatSmallText} dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                        >{this.formatNaglowek("Ulga grupa")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='nazwa_ulgi'
                                           dataFormat={this.formatSmallText} dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                        >{this.formatNaglowek("Ulga nazwa")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='proc_ulgi'
                                           dataFormat={this.formatSmallText} dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                        >{this.formatNaglowek("Ulga %")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='ilosc'
                                           dataFormat={this.formatSmallText} dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                        >{this.formatNaglowek("Ilość sprzedana")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='ilosc_popr'
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={this.formatIloscPopr} dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                        >{this.formatNaglowek("Ilość poprawna")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='cena_biletu' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatCeny(cell, row)}
                        >{this.formatNaglowek("Cena biletu")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='doplata' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatCeny(cell, row)}
                        >{this.formatNaglowek("Dopłata")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='cena_biletu_netto' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatCeny(cell, row)}
                        >{this.formatNaglowek("Cena biletu netto")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='doplata_netto' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatCeny(cell, row)}
                        >{this.formatNaglowek("Dopłata netto")}</TableHeaderColumn>

                    </BootstrapTable>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/urzadModule/bilety_miesieczne/components/UrzadMiesieczneTable.js